import {forwardRef, Link as ChakraLink, type LinkProps} from '@chakra-ui/react'
import {Link as InertiaLink, type InertiaLinkProps} from '@inertiajs/react'

export default forwardRef(function Link(
  props: LinkProps & InertiaLinkProps,
  ref
) {
  return <ChakraLink {...props} as={InertiaLink} ref={ref} />
})
